import { apiInstance } from "src/configs/axios.config";

import { TokenTypeResponse } from "src/types/pool.type";

const TOKENS_MODULE = "tokens";

export const getTokens = (configs = {}) => apiInstance.get<TokenTypeResponse[]>(`${TOKENS_MODULE}`, configs);